import { FilterFnOption } from "@tanstack/react-table";
import { ISingleSkill } from "../api/candidate/types";

export const skillsSearchingFn: FilterFnOption<any> = (row, columnId, filterValue) => {
    const skillsA = row.getValue(columnId) as ISingleSkill[];
    let skillsToString = "";
    skillsA.forEach(s => skillsToString += s.name + " ")

    return skillsToString.includes(filterValue);
};
